<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (isLoading$ | async) {
  <mat-card class="spinner-container">
    <mat-progress-spinner color="primary" mode="indeterminate">
    </mat-progress-spinner>
    Adding you to the event
  </mat-card>
}
